<template>
  <div class="w-full">
    <!-- Hero -->
    <div
      :class="[
        customisation.menu === 0 ? 'menu-0' : '',
        customisation.menu === 1 ? 'menu-1' : '',
      ]"
      class="flex flex-wrap lg:flex-nowrap layout-1"
    >
      <!-- Banner -->
      <div
        class="home-banner relative w-screen bg-center bg-cover h-2/3 hero lg:h-152 w-12/12 lg:w-1/2"
        :style="{ backgroundImage: 'url(' + settings.banner_hero + ')' }"
        :class="[userAccess ? 'admin' : '']"
      ></div>

      <!-- Text -->
      <div
        :class="[
          isDarkMode
            ? 'bg-truegray-700 text-white'
            : 'bg-truegray-100 text-truegray-700',
        ]"
        class="h-1/3 hero lg:h-152 w-screen lg:w-6/12 flex"
      >
        <div
          :class="[isDarkMode ? 'border-white' : 'border-truegray-700']"
          class="banner-text relative z-10 border-l-8 p-6 pr-8 lg:pr-12 pb-4 mt-12 lg:mt-24 ml-12 mr-4 lg:mx-12"
        >
          <h1
            v-if="settings.profile_title && settings.profile_title !== 'false'"
            class="mb-4"
          >
            {{ settings.profile_title }}
          </h1>
          <h4 v-if="settings.profile_sub_title" class="font-secondary mb-4">
            {{ settings.profile_sub_title }}
          </h4>
          <a v-if="settings.profile_description" @click="showReadMore"
            >More about us ></a
          >
        </div>
      </div>
    </div>

    <!-- Events -->
    <div
      v-if="!no_events_posts"
      :class="[isDarkMode ? 'bg-truegray-100' : 'bg-white ']"
      class="px-12 pb-16 w-full flex justify-center text-truegray-700"
    >
      <div
        class="pt-24 md:pb-36 xl:pb-12 relative w-full flex flex-col lg:flex-row max-w-screen-xl"
      >
        <div class="w-full lg:w-1/2 mb-0">
          <h1
            class="text-category opacity-20 lg:opacity-5 lg:opacity-10 pr-4 pb-2 border-b border-truegray-700 lg:mb-12"
          >
            Events
          </h1>
          <button class="btn btn-trans-black" @click="goToPosts('events')">
            View All Events
          </button>
        </div>

        <!-- remove scroll-me class and uncomment mounted event listener to turn on auto side scroll detection for off-canvas version -->
        <div
          id="eventsScroller"
          :class="
            (events_loaded && events.length > 0) || !events_loaded
              ? 'events-wrapper scroll-container'
              : 'lg:top-1/3 lg:left-2/3'
          "
          class="scroll-me w-full lg:w-2/3 lg:absolute z-20"
        >
          <div
            v-if="events_loaded && events.length > 0"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          >
            <PostsCard
              v-for="(post, i) in events"
              :id="post.id"
              :key="i"
              :ref="'events-' + i"
              :post="post"
              :parent="component_id"
              :admin_menu="false"
              :class="[!isDarkMode ? 'shadow' : '']"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- News -->
    <div
      v-if="!no_news_posts"
      :class="[
        isDarkMode && !no_events_posts ? 'bg-truegray-700 text-white' : '',
        !isDarkMode || no_events_posts ? 'light-mode' : '',
        no_jobs_posts ? '' : 'lg:pb-60',
      ]"
      class="w-full flex justify-center pt-24 pb-16 px-12"
    >
      <div class="max-w-screen-xl w-full flex flex-col lg:flex-row">
        <div class="lg:order-last order-first w-full lg:w-1/3 mb-0">
          <h1
            :class="[
              isDarkMode ? 'border-truegray-300' : 'border-truegray-500',
            ]"
            class="text-category opacity-20 lg:opacity-5 lg:opacity-10 pr-4 pb-2 border-b lg:text-right w-full lg:mb-12"
          >
            News
          </h1>
          <button
            :class="[
              isDarkMode && !no_events_posts ? 'btn-trans-white' : '',
              !isDarkMode || no_events_posts ? 'btn-trans-black' : '',
            ]"
            class="btn lg:ml-auto"
            @click="goToPosts('news')"
          >
            View All News
          </button>
        </div>
        <div
          v-if="news_loaded"
          class="w-full lg:w-2/3 grid grid-cols-1 sm:grid-cols-2 gap-4 text-black"
        >
          <NewsCard
            v-for="(post, i) in news"
            :id="post.id"
            :key="i"
            :ref="'news-' + i"
            :post="post"
          />
        </div>
      </div>
    </div>

    <!-- Jobs -->
    <div
      v-if="!no_jobs_posts"
      :class="[isDarkMode ? 'bg-truegray-100' : 'bg-white']"
      class="px-12 pb-16 w-full flex justify-center text-truegray-700 z-20"
    >
      <div
        class="pt-24 md:pb-36 xl:pb-12 relative w-full flex flex-col lg:flex-row max-w-screen-xl"
      >
        <div class="w-full lg:w-1/2 mb-0">
          <h1
            class="text-category opacity-20 lg:opacity-5 lg:opacity-10 pr-4 pb-2 border-b border-truegray-700 lg:mb-12"
          >
            Jobs
          </h1>
          <button class="btn btn-trans-black" @click="goToPosts('jobs')">
            View All Jobs
          </button>
        </div>

        <!-- remove scroll-me class and uncomment mounted event listener to turn on auto side scroll detection for off-canvas version -->
        <div
          id="jobsScroller"
          class="scroll-me scroll-container w-full lg:w-2/3 jobs-wrapper lg:absolute z-20"
        >
          <div
            v-if="jobs_loaded"
            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          >
            <PostsCard
              v-for="(post, i) in jobs"
              :id="post.id"
              :key="i"
              :ref="'jobs-' + i"
              :post="post"
              :parent="component_id"
              :admin_menu="false"
              :class="!isDarkMode ? 'border-2 border-truegray-100' : ''"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { shared } from '../../../../../../js/mixins/shared.js'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import PostsCard from '../../../../../../shared/components/PostsCard.vue'
import NewsCard from './NewsCard.vue'

export default {
  components: {
    PostsCard,
    NewsCard,
  },

  mixins: [shared],

  data() {
    return {
      news: [],
      events: [],
      jobs: [],
      news_loaded: false,
      jobs_loaded: false,
      no_news_posts: false,
      no_events_posts: false,
      no_jobs_posts: false,
      events_loaded: false,
      component_id: false,
      scroll_timeout: false,
    }
  },

  computed: {
    ...mapGetters({
      settings: 'shared/getSettings',
      user: 'shared/getUser',
      userAccess: 'shared/getUserAccess',
      currentLayout1HomeTemplateId:
        'careerwise/getCurrentLayout1HomeTemplateId',
      customisation: 'careerwise/getCustomisation',
      isDarkMode: 'careerwise/isDarkMode',
    }),
  },

  watch: {
    news_loaded: {
      handler: function () {
        if (this.news.length === 0) {
          this.$set(this, 'no_news_posts', true)
        }
      },

      deep: true,
    },

    jobs_loaded: {
      handler: function () {
        if (this.jobs.length === 0) {
          this.$set(this, 'no_jobs_posts', true)
        }
      },

      deep: true,
    },

    events_loaded: {
      handler: function () {
        if (this.events.length === 0 && this.settings.total_events === 0) {
          this.$set(this, 'no_events_posts', true)
        }
      },

      deep: true,
    },
  },

  mounted() {
    this.$set(this, 'component_id', this.makeId())
    this.dispatchSetCurrentLayout1HomeTemplate(this.component_id)

    this.getPosts('events')
    this.getPosts('news')
    this.getPosts('jobs')

    // AUTO SIDE SCROLL LISTENER FOR OVERFLOW. TURNED OFF FOR NOW. REMOVE SCROLL-ME CLASS FROM EVENT SCROLLER AND UNCOMMENT THIS TO ENABLE
    // let eventsScroller = document.getElementById('eventsScroller');
    // let jobsScroller = document.getElementById('jobsScroller');
    // eventsScroller.addEventListener("mousemove", (e) => {
    //   this.scrollerController(e, eventsScroller)
    // })
    // jobsScroller.addEventListener("mousemove", (e) => {
    //   this.scrollerController(e, jobsScroller)
    // })
  },

  methods: {
    ...mapActions({
      dispatchSetCurrentLayout1HomeTemplate:
        'careerwise/dispatchSetCurrentLayout1HomeTemplate',
    }),

    showReadMore() {
      EventBus.$emit('showModal', 'read-more')
    },

    goToPosts(type) {
      let str = '/posts?category=' + type
      this.$router.push({ path: str })
    },

    scrollerController(e, element) {
      if (this.scroll_timeout) {
        return
      }

      let width = element.offsetWidth
      let screen = window.innerWidth
      let screenX = e.clientX
      let posX = e.offsetX
      let breakpoint = width * 0.33
      let triggerPoint = screen * 0.75

      if (posX < breakpoint && screenX > triggerPoint) {
        element.classList.add('scroll-me')
        this.$set(this, 'scroll_timeout', true)
        setTimeout(() => {
          this.$set(this, 'scroll_timeout', false)
        }, 1000)
      } else if (posX < breakpoint && screenX < triggerPoint) {
        element.classList.remove('scroll-me')
        this.$set(this, 'scroll_timeout', true)
        setTimeout(() => {
          this.$set(this, 'scroll_timeout', false)
        }, 1000)
      }
    },

    getPosts(type) {
      /** Strange problem with vie router running an api call multiple times on mounted when navigating in and out of the same template.
       * We sovle this by creating a new unique component id for the template on mount and only honour the api request IF that component id is stores in $store.
       * do not want to run legacy componentns or routing api calls */
      if (this.component_id !== this.currentLayout1HomeTemplateId) {
        return
      }

      let filters = null
      let limit = 3
      switch (type) {
        case 'events':
          filters = {
            category: 3,
            draft: null,
            tag: null,
            year: null,
            keywords: null,
          }
          break

        case 'news':
          filters = {
            category: 1,
            draft: null,
            tag: null,
            year: null,
            keywords: null,
          }
          limit = 4
          break

        case 'jobs':
          filters = {
            category: 2,
            draft: null,
            tag: null,
            year: null,
            keywords: null,
          }
          break

        default:
          break
      }

      let submitData = {}
      submitData.search = filters
      submitData.limit = limit

      // Get this post...
      axios.post('/api/posts', submitData).then((response) => {
        let result = response.data
        if (result.success) {
          switch (type) {
            case 'events': {
              let rawPosts = this.validatePosts(result.posts)

              let eventsarr = rawPosts.slice(0, limit)
              this.$set(this, 'events', eventsarr)
              this.$set(this, 'events_loaded', true)
              break
            }

            case 'news': {
              let newsarr = result.posts.slice(0, limit)
              this.$set(this, 'news', newsarr)
              this.$set(this, 'news_loaded', true)
              break
            }

            case 'jobs': {
              let jobsarr = result.posts.slice(0, limit)
              this.$set(this, 'jobs', jobsarr)
              this.$set(this, 'jobs_loaded', true)
              break
            }

            default:
              break
          }
        }

        EventBus.$emit('filter_posts_search_response_completed')
      })
    },
  },
}
</script>

<style scoped>
.banner-text {
  height: fit-content;
}

.light-mode {
  position: relative;
  z-index: 20;
}
.light-mode::after {
  z-index: -1;
  width: 100%;
  height: 100%;
  content: '';
  position: absolute;
  inset: 0;
  background: var(--primary);
  opacity: 0.2;
}

.scroll-container {
  transition: all 0.3s ease-in-out;
}

@media screen and (min-width: 1024px) {
  .hero {
    height: 34rem;
  }

  .events-wrapper {
    left: 45%;
    top: -20%;
  }

  .jobs-wrapper {
    left: 45%;
    top: -20%;
  }

  .text-category {
    font-size: 80px;
  }

  .scroll-container.scroll-me {
    transform: translateX(-20%);
  }
}

@media screen and (min-width: 1250px) {
  .text-category {
    font-size: 125px;
  }
}

@media screen and (min-width: 1500px) {
  .hero {
    height: 38rem;
  }
}

@media screen and (max-width: 1024px) {
  .layout-1 {
    height: calc(100vh - 5rem);
  }
  .text-category {
    font-size: 75px;
  }
}
</style>
